<div class="map-legend-wrap">
    <div class="map-legend-title">{{ title }}</div>
    <div class="map-legend">
        <span class="map-legend-label">{{ minLabel }}</span>
        <div class="map-legend-gradient" aria-hidden="true"></div>
        <span class="map-legend-label">{{ maxLabel }}</span>
    </div>
</div>
